export interface SOAP_NOTE_GENERATION_MESSAGE {
  roomName: string;
}

export interface SoapNote {
  subjective: string;
  objective: string;
  assessment: string;
  plan: string;
}

export enum AppointmentStatus {
  Occurred = 'Occurred',
  NoShow = 'No-Show',
  Rescheduled = 'Re-Scheduled',
  Cancelled = 'Cancelled',
}

export enum SoapNoteCreationStatus {
  Pending = 'pending',
  Success = 'success',
  GenerateEmpty = 'generate_empty',
  Failed = 'failed',
}

export * from './notifications';
export * from './provider-feedback';
